import QRCode from 'qrcode';
window.QRCode = QRCode;
